import { FC, useCallback, useRef } from 'react'
import { Navigation, Pagination, Swiper as SwiperType } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { NavigationArrows } from './NavigationArrows/NavigationArrows'
import * as Styled from './ReviewsSwiperMediaSlider.styles'

const swiperModules = [Navigation, Pagination]

type ReviewsSwiperMediaSliderProps = {
  sliderAssets: Array<ReviewMedia>
  initialSlideIndex?: number
}

export type ReviewMedia = {
  src: string
  alt?: string
  type: 'image' | 'video'
}

export const ReviewsSwiperMediaSlider: FC<ReviewsSwiperMediaSliderProps> = ({
  sliderAssets,
  initialSlideIndex = 0,
}) => {
  const swiperRef = useRef<SwiperType>()

  const onBeforeSwiperInit = useCallback((swiper: SwiperType) => {
    swiperRef.current = swiper
  }, [])

  return (
    <Styled.RootWrapper>
      <Styled.GallerySliderWrapper>
        <Swiper
          initialSlide={initialSlideIndex}
          slidesPerView={1}
          spaceBetween={0}
          loop={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={swiperModules}
          zoom={false}
          onBeforeInit={onBeforeSwiperInit}
        >
          {sliderAssets.map((slide: ReviewMedia) => {
            if (slide.type === 'image') {
              return (
                <SwiperSlide key={slide.src}>
                  <Styled.GalleryImage
                    src={slide.src}
                    // TODO: `alt` is likely undefined here, but we should still support the
                    // ability for these values to be surfaced for the alt attribute if present.
                    alt={slide.alt ?? ''}
                    loading='default'
                    widths={{ unit: 'px', sm: 343, md: 373 }}
                    aspectRatios={{
                      sm: 0.75,
                      md: 0.75,
                    }}
                  />
                </SwiperSlide>
              )
            }
            if (slide.type === 'video') {
              return (
                <SwiperSlide key={slide.src}>
                  <Styled.GalleryVideo
                    autoPlay
                    muted
                    loop
                    playsInline
                    src={slide.src}
                    type={'video/mp4'}
                  />
                </SwiperSlide>
              )
            }
            return <SwiperSlide key={slide.src} />
          })}
          {sliderAssets.length > 1 ? <NavigationArrows gallerySwiperRef={swiperRef} /> : null}
        </Swiper>
      </Styled.GallerySliderWrapper>
    </Styled.RootWrapper>
  )
}
